module.exports = __webpack_public_path__ + "media/images/icons/icon-close-233fc34d13e99edf4d9c1c80d31a1e8d.png";